import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TcApiError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-api-error';
import { TcHttpError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-http-error';
import { Journey } from '@tc-core/model/it/codegen/ui/framework/journey';
import { LEVEL, ModalData } from '@tc-core/model/it/codegen/ui/framework/modal-data';
import { TC } from '@tc-core/util';
import { ConfigLoader, EventManager, UserJourneyManager } from '@tc-core/util/framework';
import { CommonHelper } from '@tc-core/util/helpers';
import { DateFormatter } from '@tc-core/util/system';
import { ChipInputComponent } from '@tc/chip-input';
import { ChipInputService } from '@tc/chip-input/chip-input.service';
import { ModalService } from '@tc/modal/modal.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { TCO } from '../../../constants';
import { SavedCriteriaV2 } from '../../../models/criteria/saved-criteria-v2';
import { ProductQueueSearchCriteria } from '../../../models/reservation-v2/criteria/product-queue-search-criteria';
import { MainType } from '../../../models/reservation-v2/main-type';
import {
    ShowSavedCriteriaModalComponent
} from '../../reservation-management/show-saved-criteria-modal/show-saved-criteria-modal.component';
import {
    ReservationV2ManagementService
} from '../../../services/backend-consumers/reservation-v2/reservation-v2-management.service';
import { DateTimeProcessor } from '../../../services/business-utils/time-zone/date-time-processor';
import { ChipHandlerService } from '../../../services/helpers/chip-handler.service';
import { RootService } from '../../../services/util/core-services/root.service';
import { ActionHandlerService } from '../../../services/util/framework/action-handler-service.service';
import { DataKey, DataStoreService } from '../../../services/util/framework/data-store.service';
import { DMCQueryParamsService } from '../../../services/util/framework/dmc-query-params.service';
import {
    OperationV2DataProcessorService
} from '../../../services/util/pre-processors/operation-v2-data-processor.service';
import {UserManagementService} from '../../../services/user-management/user-management.service';

@Component({
    selector: 'tc-product-queue-search-criteria',
    templateUrl: './product-queue-search-criteria.component.html',
    providers: [
        ChipHandlerService,
        {provide: 'ChipHandlerService', useExisting: ChipHandlerService},
        ChipInputService
    ]
})
export class ProductQueueSearchCriteriaComponent implements OnInit, OnDestroy {

    // required
    @Input() inputSearchCriteria: ProductQueueSearchCriteria;
    @Input() createNewSearchCriteriaFn: any;
    @Input() searchCriteriaUpdatingDataKey: DataKey;
    @Input() searchResultsDataKey: DataKey;
    @Input() searchCriteriaLoadingDataKey: any;
    @Input() chipConfigKey: any;
    @Input() clearLoadedSearchCriteriaFn: any;
    @Input() paginationConfigKey: any;
    @Input() placeHolderText = 'Search Items';

    @Input() isInsideForm = false;
    @Input() searchCriteriaChipConfig: string;
    @Input() isSearchBarStyleNotAvailable = false;

    @Output() searchTrigger: EventEmitter<boolean> = new EventEmitter();

    tPagination: any;
    availableChips: any[] = [];
    isDataLoaded = true;
    isChipsInit = false;
    isChipListDisplay = false;
    displayChipsArr = [];
    isFocus = false;
    modifiedChip;
    persistentQParams: string[] = [];
    persistentQParamMap = new Map<string, string>();
    persistentChipsArr = [];
    isTriggerSearch = true;
    journey: string = null;
    systemDefinedCriteriaList: SavedCriteriaV2[] = [];
    userDefinedCriteriaList: SavedCriteriaV2[] = [];

    private routerChangeSubscription: Subscription;
    private selectedChipsObsv: Subscription = new Subscription();
    private selectedFieldsObsv: Subscription = new Subscription();
    private chipValueUpdateSub: Subscription = new Subscription();
    private relatedChipsObsv: Subscription = new Subscription();
    private relatedChipsProcessObsv: Subscription = new Subscription();
    private criteriaUpdateSubscription: Subscription = new Subscription();
    private deletedChipObsv: Subscription = new Subscription();
    private savedCriteriaSearchObs: Subscription = new Subscription();
    private searchResultLoadedObs: Subscription = new Subscription();
    private selectedChips = [];
    private chipInputService;
    @ViewChild('product_queue_search_chip_input') productQueueSearchChipInput: ChipInputComponent;
    private chipHandlerSubject: Subscription = new Subscription();

    constructor(
        private configLoader: ConfigLoader,
        private dataStoreService: DataStoreService,
        private em: EventManager,
        private queryParamService: DMCQueryParamsService,
        private rootService: RootService,
        private chipHandler: ChipHandlerService,
        private commonHelper: CommonHelper,
        private userJourneyManager: UserJourneyManager,
        private actionHandlerService: ActionHandlerService,
        private modalService: ModalService,
        private dateFormatter: DateFormatter,
        private reservationV2ManagementService: ReservationV2ManagementService,
        private operationV2DataProcessorService: OperationV2DataProcessorService,
        private userManagementService: UserManagementService

    ) { }

    ngOnInit() {
        this.chipInputService = this.productQueueSearchChipInput.criteriaInputService;
        this.tPagination = this.configLoader.configurations.get(TCO.CONF.CONF_PAGINATION_CONFIG)[this.paginationConfigKey];

        // reset the search results
        this.dataStoreService.set(this.searchCriteriaUpdatingDataKey, null, true);
        this.dataStoreService.set(this.searchResultsDataKey, null, true);

        this.handleQuickActions();
        this.userJourneyManager.journey.subscribe((journey: Journey) => {
            if (journey && JSON.stringify(journey) !== JSON.stringify({})) {
                this.journey = journey.id;
            }
        });
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'SHOW_SAVED_CRITERIA').subscribe(e => {
            this.onShowSavedCriteriaClick();
        });

        this.getUserDefinedCriteriaList();
        this.getSystemDefinedCriteriaList();

        if (!this.isInsideForm) {
            this.getQueryParams();
            if (!this.isChipsInit) {
                this.initSearchCriteriaChips(); // load everything from start
            }
        }

        this.getProductQueueSearchObserver();
        this.errorObserver();
        this.selectedChipsUpdate();
        this.handleInterRelatedChips();
        this.notifyChipDelete();
        this.shortCutObserver();

        if (this.operationV2DataProcessorService.subsVar == undefined) {
            this.operationV2DataProcessorService.subsVar = this.operationV2DataProcessorService.invokeShowSearchCriteriaFunction.subscribe(
                (name: string) => {
                    this.onShowSavedCriteriaClick();
                });
        }
    }

    getQueryParams() {
        let queryParams: string[] = [];
        queryParams = this.queryParamService.getQueryParamsArray(this.inputSearchCriteria);
        this.inputSearchCriteria = this.rootService.loadRawDataFromLocalStorage(
            queryParams,
            this.createNewSearchCriteriaFn(),
            this.searchCriteriaLoadingDataKey
        );

        DateTimeProcessor.convertLocalStorageDatesToISOString(this.inputSearchCriteria);
        this.inputSearchCriteria = this.userManagementService.updateSearchCriteriaWithUserKC(this.inputSearchCriteria);
        this.inputSearchCriteria.pvtShared = this.inputSearchCriteria.pvtShared ?
            this.inputSearchCriteria.pvtShared :
            'ANY';
        this.inputSearchCriteria.language = this.inputSearchCriteria.mainType === MainType.TOU &&
        !this.inputSearchCriteria.language
            ? 'ANY' : this.inputSearchCriteria.language;
        if (this.inputSearchCriteria) {
            this.persistentQParams = [];
            this.persistentQParams = this.queryParamService.getNotNullQueryParamsArray(this.inputSearchCriteria);
        }
    }

    private shortCutObserver() {
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'FOCUS_SEARCH_BAR').subscribe(e => {
            this.isFocus = true;
        });
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'CLOSE_POPUPS').subscribe(e => {
            this.isFocus = false;
        });
    }

    onFocus(event) {
        this.isFocus = event;
    }

    initSearchCriteriaChips() {
        this.isChipsInit = true;
        this.chipInputService.fullReset();
        this.chipHandler.chipsArr = [];

        // read chip config
        let criteriaChipConfigs = null;
        if (!this.isInsideForm) {
            const chipConfigs = this.userManagementService.updateSearchChipsAccordingToUserKC(this.configLoader.configurations.get(this.chipConfigKey));
            criteriaChipConfigs = this.commonHelper.recreateJsonObject(chipConfigs);
        } else {
            const chipConfigs = this.userManagementService.updateSearchChipsAccordingToUserKC(this.configLoader.configurations.get(this.searchCriteriaChipConfig));
            criteriaChipConfigs = this.commonHelper.recreateJsonObject(chipConfigs);
        }
        this.chipHandler.setMinDateForRelatedChips(
            criteriaChipConfigs,
            this.inputSearchCriteria.startDate,
            'END_DATE'
        );

        if (this.inputSearchCriteria && this.inputSearchCriteria.bookingStartDate) {
            this.chipHandler.setMinDateForRelatedChips(criteriaChipConfigs, this.inputSearchCriteria.bookingStartDate, 'BOOKING_END_DATE');
        }

        if (criteriaChipConfigs.chips) {
            criteriaChipConfigs.chips.forEach(chip => {
                chip = this.chipHandler.preProcessChips(chip, criteriaChipConfigs.permissionKeys.keys);
            });

        }

        let isDataLoaded = false;
        this.chipHandler.chipsSubject.subscribe(data => {
            if (data && JSON.stringify(data) !== JSON.stringify([]) && !isDataLoaded) {
                isDataLoaded = true;
                this.availableChips = data;
                this.chipHandler.chipsSubject.next(null);
                if (this.chipHandlerSubject) {
                    this.chipHandlerSubject.unsubscribe();
                }

                // set values to display chips
                this.displayChipsArr = [];
                this.displayChipsArr = this.availableChips;
                this.dataStoreService.set(DataKey.chips, this.availableChips, true);
                this.chipInputService.init(this.inputSearchCriteria, this.availableChips, false, true);
                this.isChipsInit = true;

                // implement chip persistence
                if (this.persistentQParams && this.persistentQParams.length > 0) {
                    // create a queryParamMap
                    this.persistentQParams.forEach(qParam => {
                        const qParamValue = this.inputSearchCriteria[qParam];
                        if (qParam && qParamValue) {
                            this.persistentQParamMap.set(qParam, qParamValue);
                        }
                    });
                    this.persistentChipsArr = [];

                    // fill persistent chips
                    this.availableChips.forEach(chip => {
                        const persistChip = Object.assign({}, chip);
                        persistChip.optionParams.data = [];
                        let isPersist = false;
                        if (chip.dataParams && chip.dataParams.length > 0) {
                            chip.dataParams.forEach(dataParam => {
                                if (this.persistentQParamMap.has(dataParam.paramValue)) {
                                    isPersist = true;
                                    const dataObj = {
                                        key: dataParam.paramValue,
                                        value: this.persistentQParamMap.get(dataParam.paramValue)
                                    };
                                    persistChip.optionParams.data.push(dataObj);
                                }
                            });
                        }

                        // push persist chips to an array
                        if (isPersist) {
                            this.persistentChipsArr.push(persistChip);
                        }
                    });

                    // persist chips
                    if (this.persistentChipsArr && this.persistentChipsArr.length > 0) {
                        this.persistentChipsArr.forEach(value => {
                            if (value.criteriaType === 'CALENDAR' && typeof value.optionParams.data[0].value !==
                                'string') {
                                value.optionParams.data[0].value = moment(value.optionParams.data[0].value)
                                    .format('YYYY-MM-DD');
                            }
                        });

                        this.chipInputService.persistChips(this.persistentChipsArr);

                        // trigger search when chips persisting
                        this.isDataLoaded = false;
                        this.onProductQueueSearch(this.inputSearchCriteria);
                    }
                }

                this.chipInputService.criteriaUpdate.subscribe((value) => {
                    this.inputSearchCriteria = value;
                });
            }
        });
    }

    onProductQueueSearch(event) {
        this.isDataLoaded = false;
        this.inputSearchCriteria = event;
        this.userJourneyManager.canProceed.next(false);

        if (this.tPagination && this.tPagination.initialFetchingPages &&
            this.tPagination.defaultPageResultCount) {
            this.inputSearchCriteria.size = this.tPagination.initialFetchingPages *
                this.tPagination.defaultPageResultCount;
            this.inputSearchCriteria.start = 0;
        }

        this.userJourneyManager.disableQuickActions([
            'TRIGGER_EXPORT_FILE'
        ]);

        this.inputSearchCriteria = event;

        this.chipInputService.selectedChipsSubject
            .subscribe(selectedChips => {
                this.selectedChips = selectedChips;
            });

        const selectedChipsParamValues = [];
        this.selectedChips.forEach(value => {
            if ((value['chip'] && value['chip']['dataParams'] && value['chip']['dataParams'][0]['paramValue'])) {
                selectedChipsParamValues.push(value['chip']['dataParams'][0]['paramValue']);
            }
        });

        if (this.inputSearchCriteria && selectedChipsParamValues) {
            for (const item in (this.inputSearchCriteria)) {
                if (!selectedChipsParamValues.includes(item)) {
                    this.inputSearchCriteria[item] = null;
                }
            }
        }

        if (JSON.stringify(this.inputSearchCriteria) !== JSON.stringify({})) {
            this.dataStoreService.set(this.searchCriteriaUpdatingDataKey, this.inputSearchCriteria, true);
            this.dataStoreService.set(DataKey.productQueueSearchResultsFromService, null, true);

            // set criteria parameters to url
            let queryParams: string[] = [];
            queryParams = this.queryParamService.getQueryParamsArray(this.inputSearchCriteria);
            queryParams = queryParams.filter(val => val !== 'page');
            this.rootService.setDataToLocalStorage(
                this.searchCriteriaLoadingDataKey,
                this.inputSearchCriteria,
                true,
                queryParams,
                true
            );

            // remove grid sorting and filtering
            this.inputSearchCriteria.gridSorting = undefined;

            // search data
            this.reservationV2ManagementService.searchProducts(JSON.parse(JSON.stringify(this.inputSearchCriteria)));

            this.isTriggerSearch = false;
            this.searchTrigger.emit(true);

        } else {
            setTimeout(() => {
                this.isDataLoaded = true;
                this.isTriggerSearch = true;
            }, 0);
        }
    }

    getUpdatedFieldsDataObject(chip, criteria: ProductQueueSearchCriteria) {
        const dataObjArr = [];

        if (chip && chip.dataParams && chip.dataParams.length > 0) {
            chip.dataParams.forEach(dataParam => {
                const dataObj = {
                    key: '', value: ''
                };
                dataObj.key = dataParam.paramValue;
                dataObj.value = criteria[dataParam.paramValue];
                dataObjArr.push(dataObj);
            });
        }

        return dataObjArr;
    }

    private getProductQueueSearchObserver() {
        this.searchResultLoadedObs = this.dataStoreService.get(this.searchResultsDataKey)
                                         .subscribe((data) => {
                                             if (this.commonHelper.dataValidity(data)) {
                                                 setTimeout(() => {
                                                     this.isDataLoaded = true;
                                                     this.isTriggerSearch = true;
                                                 }, 0);
                                             } else if (this.commonHelper.isEmptyData(data)) {
                                                 this.isDataLoaded = true;
                                             } else if (data instanceof TcApiError) {
                                                 this.isDataLoaded = true;
                                             } else if (data instanceof TcHttpError) {
                                                 this.isDataLoaded = true;
                                             }
                                         });
    }

    private errorObserver() {
        this.dataStoreService.get(DataKey.error).subscribe((data) => {
            if (data && JSON.stringify(data) !== JSON.stringify({})) {
                setTimeout(() => {
                    this.isDataLoaded = true;
                }, 0);
                this.dataStoreService.set(DataKey.error, null);
            }
        });
    }

    private resetQueryParams() {
        let productQueueQueryParams: string[] = [];
        productQueueQueryParams = this.queryParamService.getQueryParamsArray(new ProductQueueSearchCriteria());

        const productQueueSearchCriteria1: ProductQueueSearchCriteria = this.rootService.loadRawDataFromLocalStorage(
            productQueueQueryParams,
            this.createNewSearchCriteriaFn(),
            this.searchCriteriaLoadingDataKey
        );

        // set criteria parameters to url
        let queryParams: string[] = [];
        queryParams = this.queryParamService.getQueryParamsArray(productQueueSearchCriteria1);

        this.rootService.setDataToLocalStorage(
            this.searchCriteriaLoadingDataKey,
            this.inputSearchCriteria,
            true,
            queryParams,
            true
        );
    }

    onCancel(event) {
        console.log('cancelled');
    }

    onChipListDisplay(event) {
        this.dataStoreService.set(DataKey.chipListDisplay, null, true);
        this.isChipListDisplay = event;
        this.dataStoreService.set(DataKey.chipListDisplay, this.isChipListDisplay, true);
    }

    handleQuickActions() {
        this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'TRIGGER_SEARCH_CRITERIA').subscribe((e) => {
            this.triggerSearch(e.data);
        });
    }

    triggerSearch(data: string) {
        this.inputSearchCriteria = this.createNewSearchCriteriaFn();
        this.actionHandlerService.fillCriteriaByActionData(data, this.inputSearchCriteria);
        const requiredChips = this.chipHandler.getChipsFromCriteria(
            this.inputSearchCriteria,
            this.chipConfigKey,
            true
        );
        this.chipInputService.hardReset();
        this.chipInputService.persistChips(requiredChips, true);
        this.onProductQueueSearch(this.inputSearchCriteria);
    }

    private handleInterRelatedChips() {
        this.relatedChipsObsv = this.chipInputService.relatedChipsSubject.subscribe(
            (data) => {
                let toggleChips = [];
                if (data && data.chip && JSON.stringify(data) !== JSON.stringify({})) {
                    this.modifiedChip = data.chip;
                    // TODO: refine chip input service: inter related chips
                    if (data.chip.type === 'CALENDAR') {
                        // startDate & returnDate validate
                        if (data.chip.id === 'START_DATE' || data.chip.id === 'BOOKING_START_DATE') {
                            const startDate = data.date;
                            const nights = 2;
                            const currentEndDate = this.checkDependentForCalculateRelatedDate(data.chip);

                            this.setMinDateForRelatedDateChips(data.chip, data.date);

                            if (currentEndDate) {
                                if (this.dateFormatter.isAfter(startDate, currentEndDate)) {
                                    this.chipHandler.handleInterRelatedChips(
                                        data.chip,
                                        this.dateFormatter.addDaysToDate(startDate, nights)
                                    );
                                } else {
                                    this.chipHandler.handleInterRelatedChips(data.chip, currentEndDate);
                                }
                            } else {
                                this.chipHandler.handleInterRelatedChips(
                                    data.chip,
                                    this.dateFormatter.addDaysToDate(startDate, nights)
                                );
                            }
                        }

                    } else {
                        this.chipHandler.handleInterRelatedChips(data.chip, data.options.value[0]);
                    }

                    if (data.chip.optionParams.toggleChips && data.chip.optionParams.toggleChips.length > 0) {
                        toggleChips = data.chip.optionParams.toggleChips;
                        if (toggleChips && data.options && data.options.value[0].value) {
                            this.chipInputService.selectedChipsBasedOnStateChange(toggleChips);
                        } else {
                            this.chipInputService.deleteChipsBasedOnStateChange(toggleChips);
                        }
                    }
                }
            }
        );

        this.relatedChipsProcessObsv = this.chipHandler.relatedChipsProcessSubject.subscribe((result) => {
            if (result && JSON.stringify(result) !== JSON.stringify([]) &&
                this.modifiedChip && this.modifiedChip.optionParams.relatedChips &&
                this.modifiedChip.optionParams.relatedChips.length > 0 &&
                result.length === this.modifiedChip.optionParams.relatedChips.length) {

                // if chip date is passed date it will be reset for today
                result.forEach(chip => {
                        if (chip && chip.options && chip.dataParam && chip.dataParam === 'DATE'
                            && chip.criteriaId && chip.criteriaId === 'START_DATE') {
                            chip.options = this.dateFormatter.dateFromString(chip.options) > this.dateFormatter.getToday()
                                ? chip.options
                                : this.dateFormatter.dateAsString(this.dateFormatter.getToday());
                        }
                        if (chip.dataParam === 'DATE' && chip.criteriaId === 'END_DATE') {
                            // tslint:disable-next-line:max-line-length
                            /** Following code lines are commented to give the access to set past dates for End Date chip. uncomment below lines when you need to allow the restrictions * */
                            //     chip.options = this.dateFormatter.dateFromString(chip.options) > this.dateFormatter.getToday()
                            //         ? chip.options
                            //         : this.dateFormatter.dateAsString(this.dateFormatter.getToday());
                        }
                    }
                );

                // pass related chips to chip input service
                this.chipInputService.handleInterRelatedChips(result);
            }
        });
    }

    private setMinDateForRelatedDateChips(chip: any, date: string) {
        if (date && chip && chip.optionParams && chip.optionParams.relatedChips) {
            const minDate = this.dateFormatter.dateFromString(date);
            chip.optionParams.relatedChips.forEach(relateChip => {
                if (relateChip.criteriaType === 'CALENDAR') {
                    relateChip.data = [{key: 'minDate', value: minDate}];
                }
            });
        }
    }

    private checkDependentForCalculateRelatedDate(chip: any) {
        let dateParam;
        if (chip.optionParams && chip.optionParams.relatedChips) {
            const dependent = chip.optionParams.behaviouralData.find(
                behData => behData.key === 'DATE_RELATED_DEPENDENT');
            if (dependent) {
                dateParam = this.getValueOfDependentParameter(dependent.value);
            }
        }
        return dateParam;
    }

    private getValueOfDependentParameter(dependent: any): any {
        if (this.chipInputService && this.chipInputService.criteria &&
            this.chipInputService.criteria[dependent.paramValue]) {
            return this.chipInputService.criteria[dependent.paramValue];
        }
        return '';
    }

    ngOnDestroy() {
        this.userJourneyManager.routeChanges.next(false);

        if (this.selectedChipsObsv) {
            this.selectedChipsObsv.unsubscribe();
        }
        if (this.selectedFieldsObsv) {
            this.selectedFieldsObsv.unsubscribe();
        }
        if (this.chipValueUpdateSub) {
            this.chipValueUpdateSub.unsubscribe();
        }
        if (this.criteriaUpdateSubscription) {
            this.criteriaUpdateSubscription.unsubscribe();
        }
        if (this.deletedChipObsv) {
            this.deletedChipObsv.unsubscribe();
        }
        if (this.savedCriteriaSearchObs) {
            this.savedCriteriaSearchObs.unsubscribe();
        }
        if (this.searchResultLoadedObs) {
            this.searchResultLoadedObs.unsubscribe();
        }

        this.em.removeEvents([
            'TRIGGER_SEARCH_CRITERIA'
        ]);
    }

    private selectedChipsUpdate() {
        this.criteriaUpdateSubscription = this.chipInputService.selectedChipsSubject.subscribe(selectedChips => {
            this.selectedChips = selectedChips;

            if (selectedChips && JSON.stringify(selectedChips) !== JSON.stringify([])) {
                // toggle chips when selecting BRANCH_OF_CLIENT_ID chip
                for (const selectedChip of this.selectedChips) {
                    if (selectedChip.chip.id === 'BRANCH_OF_CLIENT_ID' && selectedChip.chip.optionParams.toggleChips &&
                        selectedChip.chip.optionParams.toggleChips.length > 0) {
                        this.deleteToggleChips(selectedChip.chip.optionParams.toggleChips);
                        this.disableChips(selectedChip.chip.optionParams.toggleChips);
                        break;
                    }
                }
            }
        });
    }

    private notifyChipDelete() {
        this.deletedChipObsv = this.chipInputService.deletedChipsSubject.subscribe(deletedChip => {
            if (JSON.stringify(deletedChip) !== JSON.stringify({}) && deletedChip !== null && deletedChip !==
                undefined) {
                if (deletedChip.id === 'CLIENT_TYPE') {
                    const deleteChips = this.selectedChips.map(chip => chip.chip);
                    this.deleteSelectedChips(deleteChips);
                    this.enableChips(this.availableChips);
                } else if (deletedChip.id === 'BRANCH_OF_CLIENT_ID') {
                    if (deletedChip.optionParams.toggleChips && deletedChip.optionParams.toggleChips.length > 0) {
                        this.enableChips(deletedChip.optionParams.toggleChips);
                    }
                }
            }
            if (deletedChip && (deletedChip.id === 'BOOKING_START_DATE')) {
                const startDate = new Date();
                startDate.setFullYear(startDate.getFullYear() - 5);
                this.setMinDateForRelatedDateChips(deletedChip, startDate.toISOString().substring(0, 10));
                const currentEndDate = this.checkDependentForCalculateRelatedDate(deletedChip);
                if (currentEndDate) {
                    this.chipHandler.handleInterRelatedChips(deletedChip, currentEndDate);
                } else {
                    this.chipHandler.handleInterRelatedChips(deletedChip, startDate);
                }
            }
        });
    }

    private deleteToggleChips(toggleChips: any[]) {
        const deleteChips = [];
        toggleChips.forEach(toggleChip => {
            for (const selectedChip of this.selectedChips) {
                if (selectedChip.chip.id === toggleChip.criteriaId) {
                    deleteChips.push(selectedChip.chip);
                    break;
                }
            }
        });
        this.deleteSelectedChips(deleteChips);
    }

    private deleteSelectedChips(deleteChips: any[]) {
        deleteChips.forEach(chip => {
            this.chipInputService.deleteChip(chip, true);
        });
    }

    private enableChips(enableChips: any[]) {
        enableChips.forEach(enableChip => {
            this.chipInputService.modifyChipsStatus(enableChip, false);
        });
    }

    private disableChips(disableChips: any[]) {
        disableChips.forEach(disableChip => {
            this.chipInputService.modifyChipsStatus(disableChip, true);
        });
    }

    searchFromSavedCriteriaObserver() {
        this.isChipsInit = false;
        this.savedCriteriaSearchObs = this.dataStoreService.get(DataKey.searchFromSavedCriteria).subscribe((data) => {
            if (this.commonHelper.dataValidity(data) && !this.isChipsInit) {
                const criteriaStartDate = this.inputSearchCriteria.startDate;
                const criteriaEndDate = this.inputSearchCriteria.endDate;
                this.inputSearchCriteria = data;
                // this.inputSearchCriteria.startDate = criteriaStartDate;
                // this.inputSearchCriteria.endDate = criteriaEndDate;
                if (this.inputSearchCriteria && !this.inputSearchCriteria.startDate) {
                    this.inputSearchCriteria.startDate = new Date().toISOString().split('T')[0];
                    this.inputSearchCriteria.endDate
                        = new Date(+new Date() + 172800000)
                        .toISOString().split('T')[0];
                }

                let queryParams: string[] = [];
                queryParams.forEach(param => {
                    this.queryParamService.deleteQueryParam(param);
                });
                queryParams = this.queryParamService.getQueryParamsArray(this.inputSearchCriteria);
                queryParams = queryParams.filter(val => val !== 'page');
                this.rootService.setDataToLocalStorage(
                    this.searchCriteriaLoadingDataKey,
                    this.inputSearchCriteria,
                    true,
                    queryParams,
                    true
                );

                this.displayChipsArr = [];
                this.persistentChipsArr = [];
                this.persistentQParamMap = new Map<string, string>();
                if (this.inputSearchCriteria) {
                    this.persistentQParams = [];
                    this.persistentQParams = this.queryParamService.getNotNullQueryParamsArray(this.inputSearchCriteria);
                }
                if (!this.isChipsInit) {
                    this.initSearchCriteriaChips(); // load everything from start
                }
            }
        });
    }

    onShowSavedCriteriaClick() {
        this.dataStoreService.set(DataKey.searchFromSavedCriteria, null);
        this.dataStoreService.set(DataKey.popupClose, null);
        const dataObject = new ModalData(
            LEVEL.SUCCESS,
            'Show Criteria',
            null,
            null,
            'modal-basic--alt modal-basic--fixed-size',
            ShowSavedCriteriaModalComponent,
            {
                userDefinedCriteriaList: this.userDefinedCriteriaList,
                systemDefinedCriteriaList: this.systemDefinedCriteriaList,
                searchQueueVersion: 'V2'
            }
        );

        dataObject.secondaryHeader = '';
        this.confirmModal(dataObject);
        this.searchFromSavedCriteriaObserver();
        this.dataStoreService.get(DataKey.popupClose).subscribe((data) => {
            if (data != null) {
                this.closeModal();
            }
        });
    }

    closeModal() {
        if (this.modalService.close()) {
            this.modalService.close().subscribe((res) => {});
        }
    }

    private confirmModal(data: any): void {
        this.modalService.confirm(data).subscribe((res) => {});
    }

    getUserDefinedCriteriaList() {
        this.dataStoreService.get(DataKey.userSavedSearchCriteriaListV2).subscribe(data => {
            if (data) {
                this.userDefinedCriteriaList = data;
            }
        });
    }

    getSystemDefinedCriteriaList() {
        this.dataStoreService.get(DataKey.systemDefinedCriteriaV2).subscribe(data => {
            if (data) {
                this.systemDefinedCriteriaList = data;
            }
        });
    }
}
